import { SKILLS_CATALOGO, doCatalogo, normSkill as norm, parseSkills } from "../skills-catalogo";

/**
 * Competências do colaborador por MARCAÇÃO (checkbox), a partir do catálogo
 * padrão da SERCAMP — em vez de texto livre, que gerava grafias diferentes
 * para a mesma competência e atrapalhava a IA (treinamentos / montagem de equipe).
 *
 * Continua sendo gravado na MESMA coluna `skills` (TEXT), como lista separada
 * por ", " — exatamente o formato que a IA já usa ao concluir um treinamento.
 * Por isso competências antigas (digitadas ou gravadas pela IA) que não estão
 * no catálogo NÃO se perdem: aparecem no fim, marcadas, com o aviso
 * "fora da lista", e podem ser desmarcadas normalmente.
 */
interface Props {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}

export default function SkillsInput({ value, onChange, disabled }: Props) {
  const marcadas = parseSkills(value);
  const marcadasNorm = new Set(marcadas.map(norm));

  // Competências gravadas que não estão no catálogo (texto antigo ou da IA).
  const extras = marcadas.filter((s) => !doCatalogo(s));

  const marcada = (s: string) => marcadasNorm.has(norm(s));

  /** Monta o texto final na ordem do catálogo e depois as extras mantidas. */
  function aplicar(selecionadas: Set<string>) {
    const itensDoCatalogo = SKILLS_CATALOGO.filter((s) => selecionadas.has(norm(s)));
    const asExtras = extras.filter((s) => selecionadas.has(norm(s)));
    onChange([...itensDoCatalogo, ...asExtras].join(", "));
  }

  function alternar(skill: string) {
    const sel = new Set(marcadasNorm);
    if (sel.has(norm(skill))) sel.delete(norm(skill));
    else sel.add(norm(skill));
    aplicar(sel);
  }

  return (
    <div className="skills-box">
      {!disabled && (
        <div className="skills-actions">
          <button
            type="button"
            className="skills-link"
            onClick={() => aplicar(new Set([...SKILLS_CATALOGO, ...extras].map(norm)))}
          >
            Marcar todas
          </button>
          <span className="skills-sep">·</span>
          <button type="button" className="skills-link" onClick={() => aplicar(new Set())}>
            Limpar
          </button>
          <span className="skills-contagem">{marcadas.length} marcada(s)</span>
        </div>
      )}

      <div className="skills-grid">
        {SKILLS_CATALOGO.map((s) => (
          <label key={s} className="skills-check">
            <input
              type="checkbox"
              checked={marcada(s)}
              disabled={disabled}
              onChange={() => alternar(s)}
            />
            <span>{s}</span>
          </label>
        ))}
        {extras.map((s) => (
          <label key={s} className="skills-check skills-check-extra">
            <input
              type="checkbox"
              checked
              disabled={disabled}
              onChange={() => alternar(s)}
            />
            <span>
              {s} <em>(fora da lista)</em>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
